module.exports = __webpack_public_path__ + "img/private-schools.e426f777.png";